import glamorous from 'glamorous';
import Text from '../../../components/grey-paragraph';

const SmallGreyText = glamorous(Text)(({ theme }) => ({
    color: theme.colorGrey,
    fontSize: '16px',
}));

export default SmallGreyText;
